<button class="btn--spinner {{ btnClass }}"
        [ngClass]="{ loading: isLoading }"
        [attr.type]="btnType"
        [attr.data-id]="dataId"
        [disabled]="isDisabled"
        (click)="btnClicked($event)">
    {{ btnText }}
</button>